module.exports = __webpack_public_path__ + "static/media/external-link.3b6f60c5.svg";